module.exports = global["Modernizr"] = require("-!/code/node_modules/webpack-modernizr-loader/index.js!./.modernizrrc.js");


// WEBPACK FOOTER //
// ./app/javascript/lib/vendor_extensions/.modernizrrc.js